import {
  LIST_ITEM_OPTION,
  OPTION_EXISTING_LIST_ITEM,
  OPTION_NEW_LIST_ITEM
} from '../../../../../hooks/formHooks/listItemFormHooks/fields'
import { LINE_ITEM } from '../../../../Multiplatform/UploadAdCreative/UploadAdCreativeLineItemForm/fields'
import { startEndDateRangeInitialValues } from '../../../../ReusableFormFields/StartEndDateRangeFields/fields'
import {
  MAX_IMPRESSIONS,
  TIME_UNIT,
  TIME_UNIT_COUNT,
  timeUnits
} from './Steps/DatesStep/AdvancedSettings/FrequencyCapSection/fields'

import { LABELS } from '../reusableFields/fields'
import { OPTION_NO } from '../../../../../constants/forms'

export const ENVIRONMENT_TYPE = 'environment_type'
export const LINE_ITEM_TYPE = 'line_item_type'

export const environmentTypes = {
  VIDEO_PLAYER: 'VIDEO_PLAYER', // video ads
  BROWSER: 'BROWSER' // image ads
}

export const lineItemEnvironmentTypeLabels = {
  [environmentTypes.VIDEO_PLAYER]: 'Video line item',
  [environmentTypes.BROWSER]: 'Display line item'
}

export const roadblockingTypes = {
  CREATIVE_SET: 'CREATIVE_SET'
}

export const lineItemTypes = {
  STANDARD: 'STANDARD',
  SPONSORSHIP: 'SPONSORSHIP'
}

export const skippableAdTypes = {
  DISABLED: 'DISABLED',
  ENABLED: 'ENABLED'
}

export const ATTACH_TARGETING_OPTIONS = 'attach_targeting_options'

export const gamConstantsTypes = {
  Geo_Target: 'Geo_Target',
  Device_Category: 'Device_Category',
  Browser_Language: 'Browser_Language',
  Device_Manufacturer: 'Device_Manufacturer',
  Operating_System: 'Operating_System'
}

export const GEO_TARGETING = 'geo_targeting'
export const DEVICE_CATEGORY = 'device_category'
export const BROWSER_LANGUAGE_TARGETING = 'browser_language_targeting'
export const DEVICE_MANUFACTURER_TARGETING = 'device_manufacturer_targeting'
export const OPERATING_SYSTEM_TARGETING = 'operating_system_targeting'

export const AUDIENCE_SEGMENTS = 'audience_segments'
export const CUSTOM_TARGETING = 'custom_targeting'
export const CONTENT_TARGETING = 'content_targeting'

export const LOGICAL_OPERATOR = 'logical_operator'
export const logicalOperatorsValues = {
  AND: 'AND',
  OR: 'OR'
}

export const logicalOperatorOptions = [
  {
    value: logicalOperatorsValues.AND,
    label: 'AND'
  },
  {
    value: logicalOperatorsValues.OR,
    label: 'OR'
  }
]

export const customTargetingValueOperators = [
  {
    value: 'IS',
    label: 'Is any of'
  },
  {
    value: 'IS_NOT',
    label: 'Is none of'
  }
]

export const RIGHT_INVENTORY_SELECT = 'right_inventory_select'
export const UNITS = 'units'
export const TARGETING_OPTION = 'targeting_option'

export const targetingOptions = {
  ALL_INVENTORY: 'all_inventory',
  SPECIFIC_INVENTORY: 'specific_placements'
}

export const getInitialValues = ({ isLineItemsExist, isPercentageAllocation }) => {
  return {
    // line item environment type
    [ENVIRONMENT_TYPE]: environmentTypes.BROWSER,
    // line_item
    [LIST_ITEM_OPTION]: isLineItemsExist ? OPTION_EXISTING_LIST_ITEM : OPTION_NEW_LIST_ITEM,
    [LINE_ITEM]: '',
    // dates
    ...startEndDateRangeInitialValues,
    // frequency cap
    [MAX_IMPRESSIONS]: '',
    [TIME_UNIT]: timeUnits.DAY,
    [TIME_UNIT_COUNT]: '1',
    // labels
    [LABELS]: [],
    // targeting options
    [ATTACH_TARGETING_OPTIONS]: OPTION_NO,
    [GEO_TARGETING]: [],
    [DEVICE_CATEGORY]: [],
    [BROWSER_LANGUAGE_TARGETING]: [],
    [DEVICE_MANUFACTURER_TARGETING]: [],
    [OPERATING_SYSTEM_TARGETING]: [],
    [AUDIENCE_SEGMENTS]: [],
    [CUSTOM_TARGETING]: [],
    [CONTENT_TARGETING]: [],
    [LOGICAL_OPERATOR]: logicalOperatorsValues.AND,
    // budget
    [RIGHT_INVENTORY_SELECT]: [],
    [UNITS]: '',
    // targeting
    [TARGETING_OPTION]: isPercentageAllocation ? targetingOptions.SPECIFIC_INVENTORY : targetingOptions.ALL_INVENTORY
  }
}
